import { render, staticRenderFns } from "./user.vue?vue&type=template&id=c806d20a"
import script from "./user.js?vue&type=script&lang=js&external"
export * from "./user.js?vue&type=script&lang=js&external"
import style0 from "./user.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports